import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    background: theme.palette.grey[100],
    borderRadius: 8,
    margin: '8px 0px'
  },
  ballancedetails: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10
  },
  radio: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 8,
    marginTop: '6px',
    padding: '4px 8px'
  },
  formLabel: { fontSize: 14, color: theme.palette.text.primary },
  radiobtn: {
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '14px'
    }
  },
  textColor: { color: theme.palette.grey[600] },
  walletHeader: { display: 'flex', justifyContent: 'flex-start' },
  options: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px',
    marginTop: 4
  },
  filterText: {
    fontWeight: 600,
    color: theme.palette.grey[800],
    marginLeft: 4
  },
  name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  '@keyframes root': {
    '0%': {
      backgroundColor:
        theme.palette.type === 'dark' ? theme.palette.error.dark : 'white'
    },
    '50%': { backgroundColor: theme.palette.error.light },
    '100%': {
      backgroundColor:
        theme.palette.type === 'dark' ? theme.palette.error.dark : 'white'
    }
  },
  warning: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    background:
      theme.palette.type === 'dark'
        ? darken(theme.palette.warning.light, 0.8)
        : '#FFF8E1',

    gap: 4,
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: 8,
    margin: '8px 0 8px 0',
    animationName: '$root',
    animationDuration: '1500ms',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
    animationTimingFunction: 'linear'
  },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    fontSize: 12,
    lineHeight: '1rem',
    color: theme.palette.warning.main
  },
  icon: { fontSize: 14, color: theme.palette.warning.main },
  text: { fontWeight: 500, color: theme.palette.text.primary },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 4
  },
  selectedOption: { background: theme.palette.background.default },
  balanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '4px 0'
  },
  formControl: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
      fontWeight: 600
    }
  }
}))
export default useStyles
